import React from 'react'
import './Progressive.css';
import './Progressivecommon.css';
import MainHerosection from './mainHerosection/MainHerosection';
import Herosection from './herosection/HeroSection';
import StreamLine from './streamline/StreamLine';
import Services from './serviceprogressive/Services';
import Testimonial from './testimonialprogressive/Testimonial';
import WhyProgressive from './whyprogressive/WhyProgressive';
import EntertainmentProgressive from './entertaiment/Entertainmentprogressive';
const Progressive = () => {
  return (
    <div id='progressive'>
      <MainHerosection/>
      <WhyProgressive/>
      <Herosection />
      <StreamLine/>
      <EntertainmentProgressive/>
      <Testimonial/>
      <Services/>
    </div>
  )
}

export default Progressive;

